import { Component, OnInit } from '@angular/core';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IExam, IExamCategory } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.scss']
})
export class AddCategoryComponent implements OnInit {
  selectedCategory: IExamCategory = {
    examinationID: 0,
    numberOfQuestions: 0,
    category: '',
    instruction: '',
    maximumNumberOfEssayAnswers: 0,
    maximumNumberOfSAQAnswers: 0,
    categorySource: '',
    id: 0
  };
  text = 'Add';
  exam: IExam = examDefault;
  categoryList: Array<string> = [];
  constructor(private popoverRef: PopoverRef<AddCategoryComponent>,
    private examsevice: ExamService, private snackBar: SnackbarService, private evnt: EventService) { }

  async ngOnInit() {
    if (this.examsevice.selectedExams.length === 1) {
      this.exam = this.examsevice.selectedExams[0];
    }

    let cat = JSON.parse(sessionStorage.getItem("selectedCategory")) as IExamCategory
    if (cat) {
      this.selectedCategory = cat;
      this.text = 'Update';
    } else {
      await this.loadCategories();
    }
  }

  async loadCategories() {
     await this.examsevice.getQuestionCategories().then((c: any) => {
        console.log(c, 'cat');
        this.categoryList = c;
      });
  }

  close() {
    this.popoverRef.close();
  }

  async submitCategory() {
    if (this.selectedCategory.category === '') {
      return this.snackBar.warning("Category field is required");
    }
    if (this.selectedCategory.numberOfQuestions === 0) {
      return this.snackBar.warning("Number of Questions field is required");
    }

    this.selectedCategory.examinationID = this.exam.id;
    if (this.text == 'Update') {
      await this.updateCategory();
      sessionStorage.setItem("selectedCategory", null);
    }

    if (this.text == 'Add') { await this.saveCategory(); }

    this.evnt.adCategoryMessageEvent.emit('refreshCategory');
    this.close();
  }

  async saveCategory() {
    await this.examsevice.createExamCategory(this.selectedCategory).then((s: any) => {
      this.snackBar.success("Category saved");
    });

  }
  async updateCategory() {
    await this.examsevice.updateExamCategory(this.selectedCategory).then((s: any) => {
      this.snackBar.success("Category updated");
    });
  }
  
  mapExaminationType(label: string): string {
    switch (label) {
      case "Multiple-Choice": return "MultipleChoice";
      case "Essay": return "Essay";
      case "Interview": return "Interview";
      case "Short Answer Question": return "SAQ";
      default: return "NotSet";
    }
  }
}
